import { render, staticRenderFns } from "./MsgCenter.vue?vue&type=template&id=16f7e027&scoped=true&"
import script from "./MsgCenter.vue?vue&type=script&lang=js&"
export * from "./MsgCenter.vue?vue&type=script&lang=js&"
import style0 from "./MsgCenter.vue?vue&type=style&index=0&id=16f7e027&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7e027",
  null
  
)

export default component.exports